(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacerController', RacerController);

    RacerController.$inject = ['Racer'];

    function RacerController(Racer) {

        var vm = this;

        vm.racers = [];

        loadAll();

        function loadAll() {
            Racer.query(function(result) {
                vm.racers = result;
                vm.searchQuery = null;
            });
        }
    }
})();
